<div class="page-container">

  @if (loading()) {
    <div class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>

      <div class="loading-text">
        Fetching load details...
      </div>
    </div>
  }

  @if (
    !loading() &&
    (
      !load() ||
      load()?.deleted_at ||
      !load()?.visible
    )
  ) {
    <div class="red-container text-center">
      Load not found.
    </div>
  } @else if (!loading() && load()) {

    <h1>Load Details</h1>

    <div class="details-layout">

      <div class="left-column">

        <!-- Broker Card (Mobile) -->
        @if(isMobile) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Broker
              </mat-panel-title>
            </mat-expansion-panel-header>

              {{ load().carrier?.legal_name }}<br/>

              @if(load().carrier?.dba_name) {
                dba {{ load().carrier?.dba_name }}<br/>
              }

              {{ load().carrier?.phy_city | uppercase }},
              {{ load().carrier?.phy_state }}
              {{ load().carrier?.phy_zip }}
              <br/><br/>

              <div class="carrier-info">
                <div>
                  DOT {{ load().carrier?.dot_number }}<br />

                  {{ load().carrier?.docket_prefix }}
                  {{ load().carrier?.docket_number }}<br />

                  {{ getCarrierType(load().carrier) }}
                </div>

                <button
                  mat-button
                  class="motus-button"
                  (click)="openMotus()"
                  matTooltip="View carrier on MOTUS.gov"
                >
                  <mat-icon>open_in_browser</mat-icon>
                  MOTUS
                </button>
              </div>

              @if(load().carrier?.phone) {
                <p>P: {{ formatPhone(load().carrier?.phone) }}</p>
              } @else {
                <p>No phone number available.</p>
              }
          </mat-expansion-panel>
        }
        
        <!-- Broker Card (Desktop) -->
        @if(!isMobile) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>Broker</mat-card-title>
            </mat-card-header>

            <mat-card-content>
              {{ load().carrier?.legal_name }}<br/>

              @if(load().carrier?.dba_name) {
                dba {{ load().carrier?.dba_name }}<br/>
              }

              {{ load().carrier?.phy_city | uppercase }},
              {{ load().carrier?.phy_state }}
              {{ load().carrier?.phy_zip }}
              <br/><br/>

              <div class="carrier-info">
                <div>
                  DOT {{ load().carrier?.dot_number }}<br />

                  {{ load().carrier?.docket_prefix }}
                  {{ load().carrier?.docket_number }}<br />

                  {{ getCarrierType(load().carrier) }}
                </div>

                <button
                  mat-button
                  class="motus-button"
                  (click)="openMotus()"
                  matTooltip="View carrier on MOTUS.gov"
                >
                  <mat-icon>open_in_browser</mat-icon>
                  MOTUS
                </button>
              </div>

              <br/>

              @if(load().carrier?.phone) {
                <p>P: {{ formatPhone(load().carrier?.phone) }}</p>
              } @else {
                <p>No phone number available.</p>
              }
            </mat-card-content>
          </mat-card>
        }

        <!-- Agent Card (Mobile) -->
        @if(isMobile) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Agent
              </mat-panel-title>
            </mat-expansion-panel-header>

              <p>
                {{ load().user?.first_name }}
                {{ load().user?.last_name }}
              </p>

              @if(load().user?.direct_phone){
                <p>D: {{ formatPhone(load().user?.direct_phone) }}</p>
              }

              <p>M: {{ formatPhone(load().user?.cell_phone) }}</p>

              <p>
                <button
                  mat-button
                  class="motus-button"
                  (click)="showUserEmail()"
                  matTooltip="View email"
                >
                  <mat-icon>email</mat-icon>
                  Show Email
                </button>
              </p>
          </mat-expansion-panel>
        }
        
        <!-- Agent Card (Desktop) -->
        @if(!isMobile) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>Agent</mat-card-title>
            </mat-card-header>

            <mat-card-content>
              <p>
                {{ load().user?.first_name }}
                {{ load().user?.last_name }}
              </p>

              @if(load().user?.direct_phone){
                <p>D: {{ formatPhone(load().user?.direct_phone) }}</p>
              }

              <p>M: {{ formatPhone(load().user?.cell_phone) }}</p>

              <p>
                <button
                  mat-button
                  class="motus-button"
                  (click)="showUserEmail()"
                  matTooltip="View email"
                >
                  <mat-icon>email</mat-icon>
                  Show Email
                </button>
              </p>
            </mat-card-content>
          </mat-card>
        }
        
      </div>

      <div class="right-column">

        <mat-card>
          <mat-card-header>

            <mat-card-title>Load</mat-card-title>

            <div class="header-actions">

              <button
                mat-icon-button
                (click)="copyLink()"
                matTooltip="Share link"
              >
                <mat-icon>ios_share</mat-icon>
              </button>

              <button
                mat-icon-button
                (click)="toggleSaved()"
                [matTooltip]="load()?.is_saved ? 'Remove from saved' : 'Save load'"
              >
                <mat-icon [class.saved]="load()?.is_saved">
                  {{ load()?.is_saved ? 'favorite' : 'favorite_border' }}
                </mat-icon>
              </button>

            </div>

          </mat-card-header>

          <mat-card-content>

            <div class="details-grid">

              <div>
                <strong>Origin</strong>
                <div>{{ load().origin }}</div>
              </div>

              <div>
                <strong>Destination</strong>
                <div>{{ load().destination }}</div>
              </div>

              <div>
                <strong>Pickup</strong>
                <div>
                  {{ load().origin_start_date | date: 'MM/dd' }}

                  @if(load().origin_start_date !== load().origin_end_date && load().origin_end_date) {
                    - {{ load().origin_end_date | date: 'MM/dd' }}
                  }
                </div>
              </div>

              <div>
                <strong>Delivery</strong>
                <div>
                  {{ load().destination_start_date | date: 'MM/dd' }}

                  @if(load().destination_start_date !== load().destination_end_date && load().destination_end_date) {
                    - {{ load().destination_end_date | date: 'MM/dd' }}
                  }
                </div>
              </div>

              <div class="distance-section">
                <div>
                  <strong>Distance</strong>
                  <div>{{ load().distance | number }} mi</div>
                </div>

                <button
                  mat-icon-button
                  (click)="openGoogleMaps()"
                  matTooltip="View on Google Maps"
                >
                  <mat-icon>map</mat-icon>
                </button>
              </div>

              <div>
                <strong>Commodity</strong>
                <div>{{ load().commodity }}</div>
              </div>

              <div>
                <strong>Dimensions (L × W × H)</strong>
                <div>{{ getDimensions(load()) }}</div>
              </div>

              <div>
                <strong>Well Required</strong>
                <div>{{ toFeetAndInches(load().well_length) }}</div>
              </div>

              <div>
                <strong>Weight</strong>
                <div>{{ load().weight | number }} lbs</div>
              </div>

              <div>
                <strong>Reference</strong>
                <div>{{ load().reference }}</div>
              </div>

              @if(load().rate) {
                <div>
                  <strong>Rate</strong>
                  <div>{{ load().rate | currency:'USD':'symbol':'1.0-0' }}</div>
                </div>

                <div>
                  <strong>RPM</strong>
                  <div>{{ load().rpm | currency:'USD':'symbol' }}</div>
                </div>
              }

            </div>

            @if(tags.length > 0) {
              <mat-chip-set class="mt-10">
                @for (tag of tags; track tag) {
                  <mat-chip>{{ tag }}</mat-chip>
                }
              </mat-chip-set>
            }

          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-header>
            <mat-card-title>Notes</mat-card-title>
          </mat-card-header>

          <mat-card-content>
            {{ load().note || 'No notes provided.' }}
          </mat-card-content>
        </mat-card>

      </div>

    </div>

  }

</div>